// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnBlueTransparent_my_btn__erJT3"};